import React from "react";

export const CardProgressParesa = ({black =false, module, title, maxValue = 0, value = 0, time=0, repetitions=0 }) => {
    const percentage = ((value * 100) / maxValue)
    const color = percentage > 50 ?
        percentage >= 80 ? "#55AE70" : "#DF853C"
        : "#AE5555"

    return (
        <div className={`w-[192px] h-[176px] ${black?'bg-[#2F2F2F]':'bg-white'} rounded-2xl shadow-sm py-4`}>
            <div className="w-full text-center">
                <p className={`text-[10px] ${black?'text-[#ADADAD]':'text-[#686868]'}  font-medium`}>{module}</p>
            </div>
            <div className="pt-1 w-full text-center  px-4">
                <p className={`text-sm ${black?'text-white':'text-black'}  font-bold`}>{title}</p>
               <div className="flex items-end justify-start pb-3">
                <p className={`text-[10px] ${black?'text-[#ADADAD]':'text-[#888888]'} pr-2 w-4/12`}>Puntos</p>
                 <p
                    style={{ color: color }}
                    className={`text-[32px] font-bold leading-5 py-3`} >{value}/{maxValue}</p>                    
               </div>
                <div className="w-[160px] h-2 bg-black bg-opacity-10 rounded relative">
                    <div
                        style={{ backgroundColor: color, width: `${percentage}%` }}
                        className={`absolute h-full rounded`}></div>
                </div>
            </div>
            <div className="w-full flex justify-between pt-4 px-4">
                <p className={`w-1/2 text-[8px] font-medium ${black?'text-white':'text-black'}`} >Errores promedio </p>
                <p className={`w-1/2 text-[8px] font-medium ${black?'text-white':'text-black'}`} >Tiempo promedio </p>
            </div>
            <div className="w-full flex justify-between px-4">
                <div className="w-[65px] flex gap-x-2 pt-1">
                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                        <path d="M5.5 5.5L8.5 8.5M8.5 5.5L5.5 8.5M13 7C13 7.78793 12.8448 8.56815 12.5433 9.2961C12.2417 10.0241 11.7998 10.6855 11.2426 11.2426C10.6855 11.7998 10.0241 12.2417 9.2961 12.5433C8.56815 12.8448 7.78793 13 7 13C6.21207 13 5.43185 12.8448 4.7039 12.5433C3.97595 12.2417 3.31451 11.7998 2.75736 11.2426C2.20021 10.6855 1.75825 10.0241 1.45672 9.2961C1.15519 8.56815 1 7.78793 1 7C1 5.4087 1.63214 3.88258 2.75736 2.75736C3.88258 1.63214 5.4087 1 7 1C8.5913 1 10.1174 1.63214 11.2426 2.75736C12.3679 3.88258 13 5.4087 13 7Z" stroke="#9A9A9A" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                    <p className={`text-[10px] font-medium ${repetitions < 6 ? "text-[#55AE70]" : "text-[#AE5555]"}`} >{repetitions ? (repetitions.toFixed(2)) : 0}</p>
                </div>                
                <div className="w-1/2 flex gap-x-2  pt-1">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                        <path d="M8 4V8H11M14 8C14 8.78793 13.8448 9.56815 13.5433 10.2961C13.2417 11.0241 12.7998 11.6855 12.2426 12.2426C11.6855 12.7998 11.0241 13.2417 10.2961 13.5433C9.56815 13.8448 8.78793 14 8 14C7.21207 14 6.43185 13.8448 5.7039 13.5433C4.97595 13.2417 4.31451 12.7998 3.75736 12.2426C3.20021 11.6855 2.75825 11.0241 2.45672 10.2961C2.15519 9.56815 2 8.78793 2 8C2 6.4087 2.63214 4.88258 3.75736 3.75736C4.88258 2.63214 6.4087 2 8 2C9.5913 2 11.1174 2.63214 12.2426 3.75736C13.3679 4.88258 14 6.4087 14 8Z" stroke="#9A9A9A" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                    <p style={{ color: color }} className="text-[10px] font-medium" >{Math.round(time / 60)} min</p>
                </div>
            </div>
        </div>
    )
}

export default CardProgressParesa;
